export default "__VITE_ASSET__C8WdZXlQ__"